<div class="hospital-header">{{title}}</div>
<div *ngIf="hospitalOptions != null && hospitalOptions.length > 0" class="get-care-now-scroll-container-mobile">
    <app-hospital-option-card-mobile
        *ngFor="let option of hospitalOptions; let i = index"
        [name]="option.name"
        [photo]="option.photo"
        [phone]="option.phone"
        [address]="option.address"
        [city]="option.city"
        [state]="option.state"
        [zip]="option.zip"
        [latitude]="option.latitude"
        [longitude]="option.longitude"
        [locationDirection]="option.locationDirection"
        [distance]="option.distanceInMiles"
        [locale]="locale"
        [ngStyle]="i === 0 ? {'margin-left': '16px'} : (i === hospitalOptions.length - 1 ? {'margin-right': '16px'} : {})">
    </app-hospital-option-card-mobile>
</div>
